import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class UtilsService {
  private resourceUrl = environment.apiUrl + 'utils';

  constructor(private http: HttpClient) { }

  checkCompanyCF(cf): Observable<HttpResponse<any[]>>  {
    return this.http.post<HttpResponse<any[]>>(this.resourceUrl + '/company/cf', cf);
  }
  checkSubscriberCF(cf): Observable<any>  {
    return this.http.post<any>(this.resourceUrl + '/subscriber/check/cf', cf);
  }
  checkCompanyPI(pi): Observable<HttpResponse<any[]>>  {
    return this.http.post<HttpResponse<any[]>>(this.resourceUrl + '/company/pi', pi);
  }
  checkAddress(address): Observable<HttpResponse<any[]>>  {
    return this.http.post<HttpResponse<any[]>>(this.resourceUrl + '/location/validate', address);
  }
  checkUniqueEmail(email): Observable<HttpResponse<any>>  {
    return this.http.get<HttpResponse<any>>(this.resourceUrl + '/email/unique', {params: {email: email}});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/utils.service.ts